import { getI18n } from '@/plugins/i18n'

import { useGarageStore } from '@/stores/garage.store'

import { useLookup } from '@/composables/data-grid'
import * as dataGridColumn from '@/composables/data-grid-column'

export const useColumns = (supplierBrand = {}, currency, documentRowType) => {
  const i18n = getI18n()

  const garageStore = useGarageStore()

  return [
    dataGridColumn.useRowNumberColumn(),
    dataGridColumn.useDocumentRowTypeColumn(),
    dataGridColumn.useCostValorizationColumn(),
    {
      caption: i18n.t('common.processingType'),
      dataField: 'processing_type',
      lookup: useLookup({
        dataSource: {
          store: garageStore.getLocalizedProcessingTypes(),
          sort: 'name',
        },
        displayExpr: 'name',
      }),
      cellTemplate: 'processingType'
    },
    dataGridColumn.useSupplierBrandColumn({ supplierBrand, documentRowType }),
    ...dataGridColumn.useProductColumns({ supplierBrand }),
    dataGridColumn.useDescriptionColumn(),
    dataGridColumn.useIsMovementColumn(),
    dataGridColumn.useQuantityColumn(),
    dataGridColumn.usePriceColumn({ currency }),
    dataGridColumn.useDiscountCategoryColumn(),
    ...dataGridColumn.useVatTypeColumns(),
    dataGridColumn.useTotalNoVatColumn({ currency }),
    dataGridColumn.useTotalVatColumn({ currency }),
    dataGridColumn.useNotesColumn(),
    dataGridColumn.useDiscountColumn(),
    dataGridColumn.useDiscount2Column(),
    dataGridColumn.useDiscount3Column(),
    dataGridColumn.useChargePercentageColumn(),
    dataGridColumn.useUrgencyDiscountColumn(),
    dataGridColumn.useUrgencyDiscount2Column(),
    dataGridColumn.useUnitOfMeasureColumn(),
  ]
}
